/**
 * Artifact Sync Utilities
 * Handles bidirectional sync between chat artifacts and global artifacts
 */ /**
 * BroadcastChannel for cross-tab artifact sync
 */ const SYNC_CHANNEL_NAME = 'artifact-sync';
/**
 * Creates a BroadcastChannel for artifact synchronization
 * Returns null if BroadcastChannel is not supported
 */ export function createSyncChannel() {
    if (typeof BroadcastChannel === 'undefined') {
        console.warn('BroadcastChannel not supported in this environment');
        return null;
    }
    try {
        return new BroadcastChannel(SYNC_CHANNEL_NAME);
    } catch (error) {
        console.error('Failed to create BroadcastChannel:', error);
        return null;
    }
}
/**
 * Broadcasts an artifact update to other tabs
 */ export function broadcastArtifactUpdate(channel, artifactId, artifact) {
    if (!channel) return;
    const event = {
        type: 'update',
        artifactId,
        artifact,
        timestamp: Date.now()
    };
    try {
        channel.postMessage(event);
    } catch (error) {
        console.error('Failed to broadcast artifact update:', error);
    }
}
/**
 * Broadcasts an artifact deletion to other tabs
 */ export function broadcastArtifactDelete(channel, artifactId) {
    if (!channel) return;
    const event = {
        type: 'delete',
        artifactId,
        timestamp: Date.now()
    };
    try {
        channel.postMessage(event);
    } catch (error) {
        console.error('Failed to broadcast artifact delete:', error);
    }
}
/**
 * Sets up a listener for artifact sync events
 * Returns a cleanup function to remove the listener
 */ export function setupSyncListener(channel, onUpdate, onDelete) {
    if (!channel) return null;
    const handler = (event)=>{
        const { type, artifactId, artifact } = event.data;
        switch(type){
            case 'update':
                if (artifact) {
                    onUpdate(artifactId, artifact);
                }
                break;
            case 'delete':
                onDelete(artifactId);
                break;
        }
    };
    channel.addEventListener('message', handler);
    return ()=>{
        channel.removeEventListener('message', handler);
    };
}
/**
 * Closes a sync channel
 */ export function closeSyncChannel(channel) {
    if (channel) {
        try {
            channel.close();
        } catch (error) {
            console.error('Failed to close sync channel:', error);
        }
    }
}
